import React, { useEffect } from "react";
import { sfx } from "@/lib/soundfx";

export const ABtn = ({ children, active, tone, className = "", ...p }) => (
  <button
    {...p}
    className={`select-none rounded-md border-[3px] border-kirana-brown px-4 py-2.5 text-sm font-bold transition-transform hover:scale-[1.03] active:scale-95 hard-shadow-sm disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:scale-100 ${
      tone === "red"
        ? "bg-kirana-red text-white"
        : tone === "gold"
        ? "bg-kirana-gold text-kirana-brown"
        : tone === "green"
        ? "bg-kirana-green text-white"
        : active
        ? "bg-kirana-gold text-kirana-brown"
        : "bg-kirana-cream text-kirana-brown"
    } ${className}`}
  >
    {children}
  </button>
);

export const AResult = ({ win, text, testId }) => {
  useEffect(() => {
    if (win === true) sfx.win();
    else if (win === false) sfx.lose();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div
      data-testid={testId}
      className={`mt-3 rounded-md border-[3px] border-kirana-brown px-4 py-3 text-center font-signboard text-2xl font-bold ${
        win == null ? "bg-kirana-cream text-kirana-brown" : win ? "bg-kirana-green text-white" : "bg-kirana-red text-white"
      }`}
    >
      {text}
    </div>
  );
};

export const AScore = ({ label, value }) => (
  <span className="rounded-md border-2 border-kirana-brown bg-white px-2.5 py-1 text-sm font-bold text-kirana-brown">
    {label}: <span className="text-kirana-red">{value}</span>
  </span>
);

export const AHint = ({ children }) => (
  <p className="mb-3 text-center text-sm text-kirana-brown/70">{children}</p>
);

// Reusable on-screen control button for real-time arcade games (touch + mouse).
export const PadButton = ({ onPress, onRelease, onClick, children, testId, className = "" }) => (
  <button
    data-testid={testId}
    onPointerDown={(e) => { e.preventDefault(); onPress && onPress(); }}
    onPointerUp={() => onRelease && onRelease()}
    onPointerLeave={() => onRelease && onRelease()}
    onClick={() => onClick && onClick()}
    onContextMenu={(e) => e.preventDefault()}
    className={`flex h-12 w-12 touch-none select-none items-center justify-center rounded-md border-[3px] border-kirana-brown bg-kirana-cream text-lg font-bold text-kirana-brown hard-shadow-sm active:scale-95 ${className}`}
  >
    {children}
  </button>
);
